import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import scrollArrow from "../Assets/imgs/scrollArrow.webp";
import { heroPanelGSAP } from "../utils/GSAPFunctions";

const HeroPanel = () => {
  const heropanelRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      if (heropanelRef.current) {
        heroPanelGSAP(heropanelRef);
      }
    }, heropanelRef);

    return () => ctx.revert(); // cleanup
  }, []);

  return (
    <>
      <div className="__bannerSection" ref={heropanelRef}>
        <div className="__scroll" id="scroll_icon">
          <div className="__arrowScroll">
            <img src={scrollArrow} alt="arrow" />
          </div>
          <p>SCROLL</p>
        </div>
        <div className="__bannerText" id="bannerText">
          Your Complete
          <br /> GTM Partner
        </div>
        <div className="__bannerDesc">
          <div id="b_subheading">
            We build comprehensive marketing ecosystems that
          </div>
          <div id="b_subheading">
            power B2B SaaS, e-commerce & cybersecurity
          </div>
          <div id="b_subheading">
            companies' growth from strategy to execution.
          </div>
        </div>
        <div className="__bannerHeading" id="banner_mheading">
          DBX360
        </div>
      </div>
    </>
  );
};

export default HeroPanel;
